export default __webpack_public_path__ + "static/studentDesktop25-699e8c2fd0ae763410b195907f811f61.mp4";